<template>
  <div class="main">
    <div class="main_top">
      <div>
        <el-select
          v-model="params.state"
          placeholder="请选择试题状态"
          @change="SearchChange"
        >
          <el-option
            v-for="item in stateList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-date-picker
          style="margin-left: 20px"
          v-model="selectDate"
          type="datetimerange"
          @change="dateChange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>

      <div></div>
      <Modal
        v-model="modal1"
        title="试题详情"
        footer-hide
        :draggable="true"
        class="modal-paper"
      >
        <ul class="modal-paper-ul">
          <li v-for="(item, index) in paperdata" :key="item.examquestionid">
            <div class="parperTitle">
              <span>{{ index + 1 }}、</span>
              {{ item.title }}
            </div>
            <div class="parperBody">
              <div
                class="parperOption"
                v-for="(subitem, index) in item.options"
                :key="subitem.optionid"
                :title="subitem.optioncontent"
              >
                {{ subitem.optioncode }}、{{ subitem.optioncontent }}
              </div>
            </div>
            <div class="rightKey">题型：{{ item.typename }}</div>
            <div class="rightKey">正确答案：{{ item.answer }}</div>
            <div class="rightKey">解析：{{ item.quesanalysis }}</div>
          </li>
        </ul>
        <div style="width: 458px; margin-top: 20px; margin-left: 20px">
          <el-select
            v-model="QuestionAuditData.auditstate"
            placeholder="请选择是否通过"
            style="margin-bottom: 20px"
          >
            <el-option label="通过" value="1"> </el-option>
            <el-option label="驳回" value="2"> </el-option>
          </el-select>
          <el-input
            v-if="QuestionAuditData.auditstate == 2"
            v-model="QuestionAuditData.auditresult"
            type="textarea"
            autosize
            style="margin-bottom: 20px"
            placeholder="请输入驳回原因"
          ></el-input>
        </div>
        <div
          v-if="currentQuestin.state == '已申请'"
          style="text-align: right; padding: 0 80px"
        >
          <el-button type="primary" @click="submitAudit()">提交审核</el-button>
        </div>

        <!-- <el-form
          :model="formInline"
          :rules="ruleInline"
          ref="formInline"
          label-width="120px"
          class="demo-formInline"
        >
          <el-form-item label="题目">
            <el-input
              disabled
              v-model="formInline.title"
            ></el-input>
          </el-form-item>
          <el-form-item label="题型">
            <el-input
              disabled
              v-model="formInline.typename"
              type="text"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否置顶">
            <el-switch
              v-model="formInline.istop"
              active-text="是"
              inactive-text="否"
              style="margin-left:40px"
            >
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSubmit('formInline')"
            >提交</el-button>
          </el-form-item>
        </el-form> -->
      </Modal>
    </div>
    <div class="main_body">
      <el-table
        ref="singleTable"
        :data="newDataList"
        highlight-current-row
        @current-change="newChange"
        style="width: 100%"
        stripe=""
        :default-sort="{ prop: 'date', order: 'descending' }"
      >
        <el-table-column type="index" label="序号" align="center" width="80">
        </el-table-column>
        <el-table-column property="applyusername" label="申请人" align="center">
        </el-table-column>

        <el-table-column property="state" label="审核状态" align="center">
        </el-table-column>
        <el-table-column
          sortable
          property="appdate"
          label="申请时间"
          align="center"
        >
        </el-table-column>
        <el-table-column property="auditresult" label="驳回原因" align="center">
        </el-table-column>
        <el-table-column
          sortable
          prop="createdate"
          label="创建时间"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column fixed="right" label="审批" width="100" align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div>
        <el-pagination
          style="text-align: right; margin-top: 20px"
          :hide-on-single-page="true"
          :total="total"
          :page-size="params.pagesize"
          :current-page="params.pageindex"
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../../api/index";

export default {
  data() {
    return {
      modal1: false,
      diatitle: "",
      userSearch: "",
      newDataList: [],
      total: 1, //分页总条数
      currentQuestin: {},
      newsItem: {}, //用户选中项
      evaNameList: [], //参数名称列表
      formInline: {
        newstitle: "",
        typename: "",
        newstype: 2,
        istop: false,
        isshowgateway: "1",
      },
      ruleInline: {
        newstitle: [
          { required: true, message: "请输入标题!", trigger: "blur" },
        ],
        typename: [{ required: true, message: "请输入内容!", trigger: "blur" }],
      },
      paperdata: [],
      selectDate: "",
      params: {
        state: "",
        startdate: "",
        enddate: "",
        pagesize: 13, //每页显示数
        pageindex: 1, //当前页
      },
      stateList: [
        {
          name: "全部",
          id: "",
        },
        {
          name: "已申请",
          id: "0",
        },
        {
          name: "已审核",
          id: "1",
        },
        {
          name: "已驳回",
          id: "2",
        },
      ],
      QuestionsAuditDetails: {
        auditid: "",
        pageindex: 1,
        pagesize: 100,
      },
      QuestionAuditData: {
        auditid: "",
        auditstate: "",
        auditresult: "",
      },
    };
  },
  created() {
    this.GetDataList();
  },
  methods: {
    //搜索
    SearchChange(val) {
      this.params.state = val;
      this.GetDataList();
    },
    //用户表格选中项
    newChange(val) {
      this.newsItem = val;
    },
    dateChange(e) {
      this.params.startdate = e != null ? e[0] : "";
      this.params.enddate = e != null ? e[1] : "";
      this.GetDataList();
    },
    //获取试题审核列表
    async GetDataList() {
      console.log(this.params)
      const req = await Api.testExamine.GetExamQuestionsAuditList(this.params);
      if (req.success != true) return this.$Message.info(req.msg);
      this.newDataList = req.rows;
      this.total = req.total;
      for (let i = 0; i < this.newDataList.length; i++) {
        const element = this.newDataList[i];
        if (element.state == 0) {
          element.state = "已申请";
        } else if (element.state == 1) {
          element.state = "已审核";
        } else if (element.state == 2) {
          element.state = "已驳回";
        }
      }
    },
    //分页
    handleCurrentChange(val) {
      console.log(val)
      this.params.pageindex = val;
      this.GetDataList();
    },
    //审核试题
    async handleClick(e) {
      this.currentQuestin = e;
      this.modal1 = true;
      this.QuestionsAuditDetails.auditid = e.auditid;
      const res = await Api.testExamine.GetExamQuestionsAuditDetails(
        this.QuestionsAuditDetails
      );
      if (res.success != true) return this.$message.info(res.msg);
      this.paperdata = res.rows;
    },
    //提交审核
    async submitAudit(e) {
      this.QuestionAuditData.auditid = this.newsItem.auditid;
      const res = await Api.testExamine.ExamQuestionAudit([
        this.QuestionAuditData,
      ]);
      if (res.success != true) return this.$message.info(res.msg);
      this.$message.success(res.msg);
      this.GetDataList();
    },

    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          if (this.formInline.istop) {
            this.formInline.istop = 1;
          } else {
            this.formInline.istop = 0;
          }
          const res = await Api.baseNewsinfo.SaveData(this.formInline);
          if (res.success != true) return this.$Message.info(res.msg);
          this.$Message.success(res.msg);
          this.modal1 = false;
          this.GetDataList();
        } else {
        }
      });
    },
  },
};
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .main_top {
    display: flex;
    justify-content: space-between;
    height: 60px;
    padding: 15px 15px 0 15px;
    .search {
      width: 220px;
    }
    .dropdown {
      display: inline-block;
      margin-bottom: 0;
      font-weight: 400;
      text-align: center;
      vertical-align: middle;
      touch-action: manipulation;
      cursor: pointer;
      background-image: none;
      border: 1px solid transparent;
      white-space: nowrap;
      line-height: 1.5;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      height: 32px;
      line-height: 29px;
      padding: 0 15px;
      font-size: 14px;
      border-radius: 4px;
      transition: color 0.2s linear, background-color 0.2s linear,
        border 0.2s linear, box-shadow 0.2s linear;
      color: #515a6e;
      background-color: #fff;
      border-color: #dcdee2;
    }
    > div {
      display: flex;
      justify-content: space-between;
      > div {
        margin-right: 10px;
      }
      > button {
        margin-right: 10px;
      }
    }
  }
}
/deep/.ivu-modal-content {
  width: 570px !important;
}
/deep/.ivu-modal-body {
  padding: 15px 5px 15px 20px;
}
/deep/.modal-paper-ul {
  padding: 0 20px;
  max-height: 520px;
  overflow-y: scroll;
  li {
    > div {
      margin: 10px 0;
    }
    .rightKey,
    .parperOption {
      padding: 0 25px;
    }
    .parperBody {
      overflow: hidden;
      .parperOption {
        float: left;
        width: 50%;
        padding: 5px 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
ul::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}

ul::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  background: rgba(0, 166, 168, 0.2);
}

ul::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
</style>